import script from "./reg.vue?vue&type=script&setup=true&lang=js"
export * from "./reg.vue?vue&type=script&setup=true&lang=js"

import "./reg.vue?vue&type=style&index=0&id=12025ccc&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12025ccc"]])

export default __exports__